import axios from 'axios';
// config
import { HOST_API_KEY } from '../config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API_KEY });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
// ----------------------------------------------------------------------

export const fetcher = async (args) => {
    const [url, config] = Array.isArray(args) ? args : [args];
    console.log("url", url);
    console.log("config", { ...config });
    const res = await axiosInstance.get(url, { ...config });

    return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
    chat: 'https://api-prod-minimal-v510.vercel.app/api/chat',
    kanban: 'https://api-prod-minimal-v510.vercel.app/api/kanban',
    calendar: 'https://api-prod-minimal-v510.vercel.app/api/calendar',
    auth: {
        me: 'https://api-prod-minimal-v510.vercel.app/api/auth/me',
        login: 'https://api-prod-minimal-v510.vercel.app/api/auth/login',
        register: 'https://api-prod-minimal-v510.vercel.app/api/auth/register',
    },
    mail: {
        list: 'https://api-prod-minimal-v510.vercel.app/api/mail/list',
        details: 'https://api-prod-minimal-v510.vercel.app/api/mail/details',
        labels: 'https://api-prod-minimal-v510.vercel.app/api/mail/labels',
    },
    post: {
        list: 'https://api-prod-minimal-v510.vercel.app/api/post/list',
        details: 'https://api-prod-minimal-v510.vercel.app/api/post/details',
        latest: 'https://api-prod-minimal-v510.vercel.app/api/post/latest',
        search: 'https://api-prod-minimal-v510.vercel.app/api/post/search',
    },
    product: {
        list: 'https://api-prod-minimal-v510.vercel.app/api/product/list',
        details: 'https://api-prod-minimal-v510.vercel.app/api/product/details',
        search: 'https://api-prod-minimal-v510.vercel.app/api/product/search',
    },
};
